<template>
    <div class="app-container">
        <div class="faq-container">
            <pang-title :text="$router.lang.get('客服 中心')" eng="Customer Service"/>
            <div class="tab-container">
                <pang-tab
                :tabs="tabs" v-model:current="currentTab"/>
            </div>
            <div class="Policy" v-html="content"></div>
        </div>
    </div>
</template>

<script>

import { PangTitle, PangTab } from '../../components'
import request from '../../api/request'
import message from '../../utils/message'

const links = [
    '/customerservice/faq',
    '/customerservice/question',
    '/customerservice/terms',
]

export default {
    name: 'Terms',
    components: {
        PangTitle,
        PangTab,
    },
    data () {
        return {
            currentTab: 2,
            content: '',
            tabs: [
                'FAQ',
                this.$router.lang.get('1:1詢問'),
                this.$router.lang.get('會員條款'),
            ],
        };
    },
    watch: {
        currentTab (val) {
            this.$router.push(links[val])
        },
    },
    mounted () {
        let _this = this
        request.get('/terms/1', {}).then(function (res) {
            if (res.status == 200) {
                _this.content = res.data.article.content
            }
            else if (res.status == 404) {
                _this.$router.replace('/404')
            }
            else {
                message.resMessage(res, _this)
            }
        })
    },
}
</script>

<style scoped>

.faq-container {
    max-width: 1040px;
    width: 90vw;
    margin: 0 auto;
}

.Policy {
font-size: 14px;
color: #686A6E;
line-height: 18px;
margin-bottom: 100px;
}

</style>
